<template>
  <div>
    <h3>ESG Project Tab</h3>
    <div class="h4 py-5">呈現於ESG Page分頁Tab標題</div>

    <!-- add tab -->
    <div class="d-flex pt-5 pl-5 brand-100">
      <label><h4 class="mr-5">Tab標題</h4></label>
      <div class="d-flex my-n2 flex-grow-1">
        <div class="flex-grow-1">
          <v-text-field
            v-model="tempSpecTitle"
            placeholder="請輸入標題"
            outlined
            dense
          ></v-text-field>
        </div>
        <div class="ml-5">
          <button class="btn btn-primary w-90px" @click="addItem">
            新增
          </button>
        </div>
      </div>
    </div>

    <!-- items -->
    <div
      class="form-item d-flex pt-5 pl-5"
      v-for="(item, i) in csr.tabs"
      :key="item.id"
    >
      <label class="d-flex flex-grow-1">
        <h4 class="mr-5">Tab標題</h4>
        <div class="flex-grow-1 my-n2">
          <v-text-field
            v-model="item.title"
            placeholder="請輸入標題"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <div class="ml-5 my-n2">
        <button class="btn square mr-10px" @click="deleteItem(item)">
          <v-icon>delete</v-icon>
        </button>
        <button class="btn square mr-10px" @click="downItem(item, i)">
          <v-icon>arrow_downward</v-icon>
        </button>
        <button class="btn square" @click="upItem(item, i)">
          <v-icon>arrow_upward</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    csr: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    tempSpecTitle: '',
  }),
  methods: {
    addItem() {
      if (this.tempSpecTitle.trim() === '') {
        return;
      }

      const template = {
        title: this.tempSpecTitle.trim(),
      };

      this.csr.tabs.push(template);
      this.tempSpecTitle = '';
    },
    deleteItem(item) {
      const index = this.csr.tabs.map((option) => option.id).indexOf(item.id);
      this.csr.tabs.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.csr.tabs.length - 1) {
        this.csr.tabs.splice(i, 1);
        this.csr.tabs.unshift(item);
        return;
      }
      // item become next index
      this.csr.tabs.splice(i, 1);
      this.csr.tabs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.csr.tabs.splice(i, 1);
        this.csr.tabs.push(item);
        return;
      }
      // item become previous index
      this.csr.tabs.splice(i, 1);
      this.csr.tabs.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
